import { Controller } from "@hotwired/stimulus"

// Manages active tab state when navigating via Turbo Frame
export default class extends Controller {
  static targets = ["tab"]

  activate(event) {
    const clickedTab = event.currentTarget
    const activeClasses = "bg-red-600 text-white"
    const inactiveClasses = "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"

    this.tabTargets.forEach(tab => {
      tab.classList.remove(...activeClasses.split(" "))
      inactiveClasses.split(" ").forEach(cls => tab.classList.add(cls))
    })

    clickedTab.classList.remove(...inactiveClasses.split(" "))
    activeClasses.split(" ").forEach(cls => clickedTab.classList.add(cls))
  }
}
